/* eslint-disable multiline-ternary */
import React, { ReactElement } from "react";
import { AuthContext } from "../../../contexts/Auth/AuthContext";

// eslint-disable-next-line @typescript-eslint/no-empty-object-type
interface Props {}

export default function ForgotPassword({}: Props): ReactElement {
    const [email, setEmail] = React.useState<string>("");

    const authContext = React.useContext(AuthContext);
    return (
        <div className="login-page">
            <div className="form">
                <div className="login-form">
                    <label>Please input your email</label>
                    <br />
                    <br />
                    <br />
                    <input
                        type="text"
                        onChange={(event) => {
                            setEmail(event.target.value);
                        }}
                        placeholder="email"
                    />
                    <label style={{ color: "red" }}>
                        {authContext.state.authErrors.resetPassword}
                    </label>
                    {authContext.state.authMessages.resetPasswordSuccess ? (
                        <label style={{ color: "green" }}>
                            {
                                authContext.state.authMessages
                                    .resetPasswordSuccess
                            }
                        </label>
                    ) : (
                        <button
                            onClick={() =>
                                authContext.actions.resetPassword(email)
                            }
                        >
                            Send reset password email
                        </button>
                    )}
                </div>
            </div>
        </div>
    );
}
